import Colors from '@polestar/component-warehouse-react/tokens/colors/Colors';
const TimelineTheme = {
    timeline: {
        light: {
            lineColor: Colors.black,
            eventStates: {
                completed: { borderColor: Colors.black, backgroundColor: Colors.black },
                current: {
                    borderColor: Colors.accessibleSafetyOrange,
                    backgroundColor: Colors.accessibleSafetyOrange,
                },
                upcoming: { borderColor: Colors.black, backgroundColor: Colors.white },
            },
        },
        dark: {
            lineColor: Colors.white,
            eventStates: {
                completed: { borderColor: Colors.white, backgroundColor: Colors.white },
                current: {
                    borderColor: Colors.accessibleSafetyOrange,
                    backgroundColor: Colors.accessibleSafetyOrange,
                },
                upcoming: { borderColor: Colors.white, backgroundColor: Colors.black },
            },
        },
    },
};
export default TimelineTheme;
